import { addMonths, isAfter, isBefore, isValid, isWithinInterval, parse } from 'date-fns';
import type { DateRange } from 'react-day-picker';

export const addMonthsToDate = (date: Date, months: number): Date => addMonths(date, months);

export const isDateAfter = (date: Date, dateToCompare?: Date): boolean | undefined => {
    if (!dateToCompare) {
        return undefined;
    }

    return isAfter(date, dateToCompare);
};

export const isDateBefore = (date: Date, dateToCompare?: Date): boolean | undefined => {
    if (!dateToCompare) {
        return undefined;
    }

    return isBefore(date, dateToCompare);
};

export const isDateValid = (date: Date | undefined): boolean => isValid(date);

export const isDateWithinInterval = (date: Date, interval: Interval): boolean =>
    isWithinInterval(date, interval);

export const parseDateString = (dateString: string, dateFormat: string): Date =>
    parse(dateString, dateFormat, new Date());

export const parseDateRange = ({
    format: dateFormat,
    from,
    to
}: {
    format: string;
    from: string;
    to: string;
}): DateRange => {
    const parsedFrom = parse(from, dateFormat, new Date());
    const parsedTo = parse(to, dateFormat, new Date());

    parsedFrom.setHours(0);
    parsedTo.setHours(23);

    return { from: parsedFrom, to: parsedTo };
};

export const validateDateRange = (dates: DateRange): DateRange | false => {
    const { from, to } = dates;

    if (!from || !to) {
        return false;
    }

    if (!isValid(from) || !isValid(to)) {
        return false;
    }

    if (isAfter(from, to)) {
        const swappedFrom = new Date(to);
        const swappedTo = new Date(from);

        swappedFrom.setHours(0);
        swappedTo.setHours(23);

        return { from: swappedFrom, to: swappedTo };
    }

    return dates;
};
